import React from 'react';

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import EmptyState from '@atlaskit/empty-state';

import ErrorSVG from '../../assets/Error.svg';

import messages from './messages';
import { type ErrorStateProps } from './types';

export const ErrorState = ({ title }: ErrorStateProps) => {
	const { formatMessage } = useIntl();
	return (
		<EmptyState
			header={title || formatMessage(messages.errorStateTitle)}
			description={formatMessage(messages.errorStateDescription)}
			headingLevel={2}
			primaryAction={
				<Button onClick={() => window.location.reload()} appearance="primary">
					{formatMessage(messages.errorStateCTA)}
				</Button>
			}
			width="wide"
			imageUrl={ErrorSVG}
		/>
	);
};
